import BaseModal from "../common/HPBaseModal";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { ModalProps } from "@_constants/modal";

interface ConfigureCadenceModalProps extends ModalProps {
  surveyName: string;
  onYes: () => void;
  onNo: () => void;
}

const ConfigureCadenceModal: React.FC<ConfigureCadenceModalProps> = ({
  surveyName,
  onYes,
  onNo,
}) => {
  return (
    <BaseModal
      onConfirm={onYes}
      onCancel={onNo}
      title="Configure Update Schedule"
      confirmButtonText="Yes, Configure"
      cancelButtonText="No, Thanks"
      confirmButtonIcon={<ScheduleIcon />}
    >
      <div className="space-y-4">
        <p className="text-gray-700">
          Survey <span className="font-semibold">{surveyName}</span> has been
          successfully imported.
        </p>
        <p className="text-gray-700">
          Would you like to configure an automatic update schedule for this
          survey?
        </p>
        <div className="bg-blue-50 border border-blue-200 rounded-md p-3">
          <p className="text-sm text-blue-800">
            You can set up daily, weekly, or monthly automatic updates to keep
            your survey data current.
          </p>
        </div>
      </div>
    </BaseModal>
  );
};

export default ConfigureCadenceModal;
